import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export interface TemperatureSnapshot extends Snapshot {
    value: number | null;
    units: string | null;

    minMeasured: number | null;
    maxMeasured: number | null;

    minRange: number | null;
    maxRange: number | null;
}

export const temperatureSnapshotSchema = snapshotSchema.extend({
    value: z.number().nullable(),
    units: z.string().nullable(),

    minMeasured: z.number().nullable(),
    maxMeasured: z.number().nullable(),

    minRange: z.number().nullable(),
    maxRange: z.number().nullable(),
});

export const mockTemperatureSnapshot = ({
    value = 1,
    units = 'degrees',

    minMeasured = 0,
    maxMeasured = 100,

    minRange = 1,
    maxRange = 2,

    ...snapshot
}: Partial<TemperatureSnapshot> = {}): TemperatureSnapshot => ({
    ...mockSnapshot(snapshot),

    value,
    units,

    minMeasured,
    maxMeasured,

    minRange,
    maxRange,
});
